export const SUCCESS = "Success";
export const ERROR = "Error";
export const SCHEMA="http://powerbi.com/product/schema#basic"
export const VISUAL_KEY="e88a5406330704a4134e"
export const COOKIE_KEYS = [
  "husk.user",
  "husk.globalAdmin",
  "husk.country",
  "customerId"
];

// Country configuration for header and app-wide use
export const COUNTRY_CONFIG = {
  IN: {
    flag: "https://flagcdn.com/w40/in.png",
    name: "India",
    alt: "India Flag"
  },
  NG: {
    flag: "https://flagcdn.com/w40/ng.png", 
    name: "Nigeria",
    alt: "Nigeria Flag"
  }
} as const;

export type CountryCode = keyof typeof COUNTRY_CONFIG;

export const MAX_FILE_SIZE_MB = 5; 

export const ACCEPTED_EXCEL_MIME_TYPES=["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel"];

export const BASE_PATH = '/fms';
export const FMS_API_URL = 'https://dev-fms-api.huskneuron.com';
export const PROXY_PATH = '/fms-api';

export const REMOTE_PATHS = ['/dashboard', '/task-management', '/pole-management', 
      '/travel-management', '/inventory-management', '/drag-down-configuration',
      '/approval', '/tasks', '/task/', '/notifications'];

// Ugx Remote App Configuration
export const Ugx_BASE_PATH = '/Ugx';
export const Ugx_API_URL = 'https://api.Ugx.com';
export const Ugx_PROXY_PATH = '/Ugx-api';
export const Ugx_REMOTE_PATHS = ['/dashboard', '/reports', '/settings'];